module.exports = __webpack_public_path__ + "static/media/Avatar8.b11461e4.svg";